import { render, staticRenderFns } from "./JBProposalEntrustments.vue?vue&type=template&id=7fb46e60"
import script from "./JBProposalEntrustments.vue?vue&type=script&lang=js"
export * from "./JBProposalEntrustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports